import { render, staticRenderFns } from "./triangle-badge.vue?vue&type=template&id=7aab0934&scoped=true"
import script from "./triangle-badge.vue?vue&type=script&lang=js"
export * from "./triangle-badge.vue?vue&type=script&lang=js"
import style0 from "./triangle-badge.vue?vue&type=style&index=0&id=7aab0934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aab0934",
  null
  
)

export default component.exports